import React, { useEffect, useContext, useState, lazy, Suspense } from "react";
import { CircularProgress } from "@mui/material";
import { LangContext } from "../../../context/AppContext";
import { api_homepage } from "../../../api/page/home";
import { getToken } from "../../../localstorage";

const HomeHeroSection = lazy(() => import("./HomeHeroSection/HomeHeroSection"));
const HomeAboutArea = lazy(() => import("./HomeAboutArea/HomeAboutArea"));
const HomeHealthPackages = lazy(() =>
  import("./HomeHealthPackage/HomeHealthPackage")
);
const HomeHealthTourism = lazy(() =>
  import("./HomeHealthTourism/HomeHealthTourism")
);
const HomeInsightsCorner = lazy(() =>
  import("./HomeInsightsCorner/HomeInsightsCorner")
);
const HomeAward = lazy(() => import("./HomeAward/HomeAward"));

const Home = () => {
  const { selectedLanguage } = useContext(LangContext);
  const token = getToken();
  const [isLoading, setLoading] = useState(true);
  const [Section1Data, setSection1Data] = useState({
    section1_title: '',
    section1_banner: '',
    section2_speciality_banner: '',
    section2_whyus_description: '',
    section2_whyus_title: '',
    section1_banner_slide: [],
  });

  const [Section2Data, setSection2Data] = useState({
    section2_speciality_banner: '',
  });

  const [Section4Data, setSection4Data] = useState({
    section4_healthtourism_main_title: '',
    section4_healthtourism_main_description: '',
    section4_healthtourism1_title: '',
    section4_healthtourism1_description: '',
    section4_healthtourism1_image: '',
    section4_healthtourism2_title: '',
    section4_healthtourism2_description: '',
    section4_healthtourism2_image: '',
    section4_healthtourism3_title: '',
    section4_healthtourism3_description: '',
    section4_healthtourism3_image: '',
  });

  const [Section5Data, setSection5Data] = useState({
    section5_banner: '',
    section5_title: '',
    section5_description: '',
    section5_image: '',
    section5_image2: '',
    section5_image3: '',
  });

  const [Section6Data, setSection6Data] = useState({
    section6_award_accre_title: '',
    section6_award_accre_description: '',
    kpj_page_home_to_award_accre_images: '',
  });

  const [HeathpackageData, setHeathpackageData] = useState({
    healthpackage: [],
  });

  useEffect(() => {
    document.title = "KPJ Healthcare | Malaysia's Preferred Healthcare Partner in Specialist Care - Care for Life";
    document.querySelector('meta[name="description"]')?.setAttribute("content", "KPJ Healthcare is the preferred partner in specialist care in Malaysia. Guided by our philosophy of Care for Life, we provide trusted, patient-centered services across 30 hospitals nationwide.");
  }, []);

  useEffect(() => {
    api_homepage(selectedLanguage)
      .then((data) => {
        if (data.status) {
          setLoading(false);

          setSection1Data({
            section1_title: data.data.section1_title,
            section1_banner: data.data.section1_banner,
            section1_banner_slide: data.data.section1_banner_slide,
            section2_speciality_banner: data.data.section2_speciality_banner,
            section2_whyus_description: data.data.section2_whyus_description,
            section2_whyus_title: data.data.section2_whyus_title,
          });

          setSection2Data({
            section2_speciality_banner: data.data.section2_speciality_banner,
            section2_speciality_mobile_banner: data.data.section2_speciality_mobile_banner,
            section2_speciality_content: data.data.section2_speciality_content,
            section2_speciality_image: data.data.section2_speciality_image,
            section2_2_speciality_image: data.data.section2_2_speciality_image,
            section2_2_speciality_content:
              data.data.section2_2_speciality_content,
            section2_3_speciality_image: data.data.section2_3_speciality_image,
            section2_3_speciality_content:
              data.data.section2_3_speciality_content,
            specialty_center: data.data.specialty_center,
            specialty_centers: data.data.specialty_centers,
          });

          setSection4Data({
            section4_healthtourism_main_title:
              data.data.section4_healthtourism_main_title,
            section4_healthtourism_main_description:
              data.data.section4_healthtourism_main_description,
            section4_healthtourism1_title:
              data.data.section4_healthtourism1_title,
            section4_healthtourism1_description:
              data.data.section4_healthtourism1_description,
            section4_healthtourism1_image:
              data.data.section4_healthtourism1_image,
            section4_healthtourism1_mobile_image:
              data.data.section4_healthtourism1_mobile_image,
            section4_healthtourism2_title:
              data.data.section4_healthtourism2_title,
            section4_healthtourism2_description:
              data.data.section4_healthtourism2_description,
            section4_healthtourism2_image:
              data.data.section4_healthtourism2_image,
            section4_healthtourism2_mobile_image:
              data.data.section4_healthtourism2_mobile_image,
            section4_healthtourism3_title:
              data.data.section4_healthtourism3_title,
            section4_healthtourism3_description:
              data.data.section4_healthtourism3_description,
            section4_healthtourism3_image:
              data.data.section4_healthtourism3_image,
            section4_healthtourism3_mobile_image:
              data.data.section4_healthtourism3_mobile_image,
          });

          setSection5Data({
            section5_banner: data.data.section5_banner,
            section5_mobile_banner: data.data.section5_mobile_banner,
            section5_title: data.data.section5_title,
            section5_description: data.data.section5_description,
            section5_image: data.data.section5_image,
            section5_mobile_image: data?.data?.section5_mobile_image,
            section5_image2: data.data.section5_image2,
            section5_mobile_image2: data?.data?.section5_mobile_image2,
            section5_image3: data.data.section5_image3,
            section5_mobile_image3: data?.data?.section5_mobile_image3,
          });

          setSection6Data({
            section6_award_accre_title: data.data.section6_award_accre_title,
            section6_award_accre_description:
              data.data.section6_award_accre_description,
            kpj_page_home_to_award_accre_images:
              data.data.kpj_page_home_to_award_accre_images,
          });

          setHeathpackageData({
            healthpackage: data.data.healthpackage,
            hp_title: data.data.section3_healthpackages_title,
            hp_description: data.data.section3_healthpackages_description,
          });
        }
      })
      .catch((error) => {
        // console.log(error);
      });
  }, [selectedLanguage, token]);

  if (isLoading) {
    return (
      <div className="loading-container">
        <CircularProgress />
      </div>
    );
  }

  return (
    <Suspense
      fallback={
        <div className="loading-container">
          <CircularProgress />
        </div>
      }
    >
      <div style={{ backgroundColor: "#f3f5f7" }}>
        <HomeHeroSection apidata={Section1Data} />
        <HomeAboutArea apidata={Section2Data} />
        <HomeHealthPackages apidata={HeathpackageData} />
        <HomeHealthTourism apidata={Section4Data} />
        <HomeInsightsCorner apidata={Section5Data} />
        <HomeAward apidata={Section6Data} />
      </div>
    </Suspense>
  );
};
export default Home;
